// components/Modal.js
import React from "react";

const ModelPopUp = ({ show, onClose, title, description, imageUrl }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
  <div className="relative w-full sm:w-[80%] md:w-[60%] lg:w-[50%] xl:w-[40%] bg-white rounded-xl shadow-xl p-6 pt-8 animate-scale-in mx-4">
    {/* Close Button */}
    <button
      className="absolute top-1 right-3 text-black hover:text-gray-600 text-2xl"
      onClick={onClose}
      aria-label="Close"
    >
      &times;
    </button>

    {/* Content */}
    <div className="text-center">
      <h2 className="text-xl font-semibold text-gray-800 mb-2">
        {title}
      </h2>
      <p className="text-base text-gray-600 mt-4 mb-4">{description}</p>
    </div>

    {/* Image */}
    {imageUrl && (
      <div className="flex justify-center mb-4">
        <img src={imageUrl} alt="Modal Visual" className="w-full h-auto max-w-[80%]" />
      </div>
    )}
  </div>
</div>

  );
};

export default ModelPopUp;
